import styled from "styled-components";

export const Logo = styled.p`


    

`

export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 900px) {
        display: flex;
        position: absolute;
        right: -10%;
        transform: translate(-350%, 0%);
        font-size: 1.8rem;
        cursor: pointer;
        color: white;
        z-index: 15;
    }

    @media (max-width: 768px) {
        transform: translate(-160%, 0%);
        right: -5%;
    }
`